const BASE = process.env.REACT_APP_APIURL || 'http://localhost:4000/';
const api = (path) => `${BASE.replace(/\/$/, '')}/${path}`;

export class UsuarioApi {
  async verifyUser(user) {
    const res = await fetch(api('usuario/verify'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id:        user.id,
        username:  user.username,
        role:      user.role,
        email:     user.email     || '',
        firstName: user.firstName || '',
        lastName:  user.lastName  || '',
      }),
    });
    if (!res.ok) throw new Error(`verifyUser: ${res.status}`);
    return res.json();
  }

  async getAllUsuarios() {
    const res = await fetch(api('usuario'));
    if (!res.ok) throw new Error(`getAllUsuarios: ${res.status}`);
    return res.json();
  }
}
